<template>
  <Teleport to="body">
    <div
      v-if="isOpen"
      class="fixed inset-0 z-[200] flex items-center justify-center bg-black/75 p-4 backdrop-blur-sm"
      role="dialog"
      aria-modal="true"
      :aria-labelledby="step === 'prompt' ? 'age-gate-title' : 'age-gate-denied-title'"
    >
      <div class="w-full max-w-md rounded-2xl border border-default bg-default p-6 shadow-2xl sm:p-8">
        <template v-if="step === 'prompt'">
          <div class="mb-6 text-center">
            <div class="mx-auto mb-4 flex h-14 w-14 items-center justify-center rounded-full bg-amber-100 text-amber-700">
              <UIcon name="i-heroicons-exclamation-triangle" class="h-7 w-7" />
            </div>
            <h2 id="age-gate-title" class="text-xl font-bold text-highlighted">
              E necesară confirmarea vârstei
            </h2>
            <p class="mt-2 text-sm text-muted">
              înainte de a accesa acest site
            </p>
            <p class="mt-4 text-base font-medium text-toned">
              Ai peste 18 ani?
            </p>
          </div>

          <div class="flex flex-col gap-3">
            <UButton
              label="Da, am împlinit 18 ani"
              color="primary"
              block
              @click="confirmAge"
            />
            <UButton
              label="Nu, am sub 18 ani"
              color="neutral"
              variant="soft"
              block
              @click="denyAge"
            />
          </div>
        </template>

        <template v-else>
          <div class="text-center">
            <div class="mx-auto mb-4 flex h-14 w-14 items-center justify-center rounded-full bg-red-100 text-red-600">
              <UIcon name="i-heroicons-no-symbol" class="h-7 w-7" />
            </div>
            <h2 id="age-gate-denied-title" class="text-xl font-bold text-highlighted">
              Te așteptăm după majorat!
            </h2>
            <p class="mt-3 text-sm leading-relaxed text-muted">
              Trebuie să ai vârsta de minim 18 ani
              pentru a intra pe acest site.
            </p>
          </div>
        </template>
      </div>
    </div>
  </Teleport>
</template>

<script setup lang="ts">
import { isAgeVerificationValid, saveAgeVerification } from '~/utils/ageVerification'

const shopSlug = useShopSlug()
const { ageVerificationEnabled } = useSiteSettings()

const step = ref<'prompt' | 'denied'>('prompt')
const verified = ref(false)

const isOpen = computed(() =>
  ageVerificationEnabled.value && !verified.value,
)

function refreshVerified() {
  if (!import.meta.client) return
  verified.value = isAgeVerificationValid(shopSlug.value)
}

function confirmAge() {
  saveAgeVerification(shopSlug.value)
  verified.value = true
}

function denyAge() {
  step.value = 'denied'
}

watch(isOpen, (open) => {
  if (!import.meta.client) return
  document.body.style.overflow = open ? 'hidden' : ''
}, { immediate: true })

watch(shopSlug, () => {
  step.value = 'prompt'
  refreshVerified()
})

onMounted(() => {
  refreshVerified()
})

onBeforeUnmount(() => {
  if (import.meta.client) {
    document.body.style.overflow = ''
  }
})
</script>
